<template>
  <v-dialog v-model="localShow" :max-width="800" :persistent="true" :fullscreen="isMobile">
    <v-card id="dialog-body">
      <v-card-title class="d-flex align-center pb-0">
        <v-spacer />
        <v-icon start>mdi-swap-horizontal</v-icon>
        Select Account to Navigate to
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="cancel" />
      </v-card-title>
      <div class="ml-4 mb-4">
        <v-text-field
          v-model="searchQuery"
          prepend-icon="mdi-magnify"
          :label="searchLabel"
          single-line
          hide-details
          class="mr-4"
        ></v-text-field>
      </div>
      <div id="dialog-table">
        <v-data-table
          disable-pagination
          :hide-default-header="true"
          :hide-default-footer="true"
          :must-sort="true"
          :no-data-text="''"
          :headers="headers"
          :items="allCompaniesExceptCurrent"
          :search="searchQuery"
          @click:row="(event, { item }) => selectCompany(item)"
        >
          <template v-slot:item.icon="{}">
            <v-icon>mdi-warehouse</v-icon>
          </template>
          <template v-slot:item.name="{ item }">
            <div v-html="highlight(item.name, searchQuery)"></div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import filterService from "@/services/filterService.js";
import responsiveService from "@/services/responsiveService";
import { mapGetters } from "vuex";
import Auth0Mixin from "../views/Auth0Mixin";

export default {
  name: "ChangeCompany",
  mixins: [Auth0Mixin],
  props: {
    show: Boolean,
    cancel: Function,
  },
  emits: ["update:show"],
  data() {
    return {
      localShow: this.show,
      headers: [
        { title: "", key: "icon", width: 40 },
        { title: "Name", key: "name" },
      ],
      searchQuery: "",
      searchLabel: "Account Name",
      allCompaniesExceptCurrent: [],
      highlight: filterService.highlight,
    };
  },

  watch: {
    show(val) {
      this.localShow = val;
    },
    localShow(val) {
      if (!val) this.$emit("update:show", val);
    },
  },

  computed: {
    ...mapGetters("auth0Store", ["companies", "selectedCompanyId"]),
    isMobile() {
      return responsiveService.isMobile(this.$vuetify.display);
    },
  },

  methods: {
    async init() {
      this.allCompaniesExceptCurrent = this.companies.filter(x => x.id != this.selectedCompanyId);
    },
    selectCompany(company) {
      if (company.isCloud) {
        const url = company.url;
        window.location.href = `${url}/repository`;
      } else {
        this.$store.dispatch("auth0Store/updateCompanyId", { selectedCompanyId: company.id });
        window.location.href = "/";
      }
    },
  },
};
</script>

<style>
/* Hiding the headers breaks the column width specified, therefore this css is needed */
#dialog-table colgroup > :first-child {
  width: 40px;
  min-width: 40px;
}

#dialog-table {
  min-height: 300px;
}

#dialog-body {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
